<template>
  <div class="form-teeth-formula">
    <div class="form-teeth-formula__diagnoses">
      <input-checkbox
        class="form-teeth-formula__checkbox"
        title="Зуб удален"
        v-bind:disabled="onlyView"
        v-bind:value="isDeleted"
        v-on:input="emitChangeToothDeleted"
      />
      <template v-if="!isDeleted || hasImplant">
        <div
          v-for="part in sortedParts"
          v-bind:key="part.id">
          <h3 class="form-teeth-formula__title">{{ part.name }}</h3>
          <div class="form-teeth-formula__items">
            <input-checkbox
              class="form-teeth-formula__checkbox"
              v-for="({ diagnosis, value }) in part.diagnoses"
              v-bind:key="diagnosis.id"
              v-bind:disabled="onlyView"
              v-bind:style="{ 'background-color': diagnosis.color }"
              v-bind:title="diagnosis.name"
              v-bind:value="value"
              v-on:input="emitChangeDiagnoses(part.id, diagnosis.id, $event)"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div
          v-for="part in availableDeletedParts"
          v-bind:key="part.id">
          <h3 class="form-teeth-formula__title">{{ part.name }}</h3>
          <div class="form-teeth-formula__items">
            <input-checkbox
              class="form-teeth-formula__checkbox"
              v-for="({ diagnosis, value }) in part.diagnoses"
              v-bind:key="diagnosis.id"
              v-bind:disabled="onlyView"
              v-bind:style="{ 'background-color': diagnosis.color }"
              v-bind:title="diagnosis.name"
              v-bind:value="value"
              v-on:input="emitChangeDiagnoses(part.id, diagnosis.id, $event)"
            />
          </div>
        </div>
      </template>
    </div>
    <div class="form-teeth-formula__buttons">
      <button
        v-if="onlyView"
        class="form-teeth-formula__button-cancel"
        type="button"
        v-on:click="onCancel">
        Закрыть
      </button>
      <template v-else>
        <button
          class="form-teeth-formula__button-cancel"
          type="button"
          v-on:click="onCancel">
          Отмена
        </button>
        <button
          class="form-teeth-formula__button-ok"
          type="button"
          v-on:click="onSubmit">
          ОК
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import InputCheckbox from '@/components/InputCheckbox.vue';

export default {
  components: { InputCheckbox },
  computed: {
    sortedParts: ({ partList }) => partList.sort((a, b) => a.id > b.id),
    availableDeletedParts: ({ partList }) => partList.reduce(
      (diagnoses, candidate) => {
        const part = { ...candidate };
        part.diagnoses = candidate.diagnoses.filter(
          (diagnosis) => diagnosis.diagnosis.id === 'implant',
        );
        if (part.id === 'bone' && part.diagnoses.length) {
          diagnoses.push(part);
        }
        return diagnoses;
      },
      [],
    ),
  },
  methods: {
    onSubmit() {
      this.$emit('submit');
    },
    onCancel() {
      this.$emit('cancel');
    },
    emitChangeToothDeleted(isDeleted) {
      this.$emit('change-tooth-deleted', isDeleted);
    },
    /**
     * @description Отправить событие изменения диагноза части зуба.
     * @param {string}  partId      Идентификатор части.
     * @param {string}  diagnosisId Идентификатор диагноза.
     * @param {boolean} isSelected  Выбран.
     * @returns {void}
     */
    emitChangeDiagnoses(partId, diagnosisId, isSelected) {
      this.$emit('change-diagnoses', partId, diagnosisId, isSelected);
    },
  },
  inject: ['onlyView'],
  props: {
    /**
     * @description Части зуба.
     * @type {Part[]}
     */
    partList: { type: Array, required: true },
    /**
     * @description Удален.
     * @type {boolean}
     */
    isDeleted: { type: Boolean, required: true },
    /**
     * @description Установлен ли имплант
     * @type {Boolean}
     */
    hasImplant: {
      type: Boolean,
      required: true,
    },
  },
  name: 'FormTeethFormulaDiagnoses',
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.form-teeth-formula {
  min-width: 263px;
  padding: 0 0 20px 20px;
  max-height: 400px;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 20px;
  &__diagnoses {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 20px 20px 0 0;
    position: relative;
  }
  &__title {
    color: #000000;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    text-align: left;
    margin: 0 0 12px 0;
  }
  &__items {
    display: flex;
    flex-direction: column;
    gap: 7px;
  }
  &__checkbox {
    display: flex;
    padding: 4px 8px 4px 4px;
    border-radius: 4px;
    color: #192a3e;
    cursor: pointer;
    text-align: left;
    width: 100%;
  }
  &__buttons {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding-right: 20px;
    gap: 6px;
  }
  &__button {
    &-cancel {
      @include buttons.btn-transparent(100%, 40px, 16px);
    }
    &-ok {
      @include buttons.btn-blue(100%, 40px, 16px);
    }
  }
}
</style>
